// extracted by mini-css-extract-plugin
export default {"galleryItem":"c-n_fz","galleryItem_borderTopRadius":"c-n_fA","galleryItem__image":"c-n_fB"};